<div class="header-wrapper">
  <div class="header-content">
    <a [href]="'https://kimba.tv/'" target="_blank">
      <mat-icon [svgIcon]="'logo'" style="height: 40px; width: 40px;"></mat-icon>
    </a>
    <div class="header-icons">
      <a [href]="'https://discord.gg/k1m6a'" target="_blank">
        <mat-icon [svgIcon]="'discord'"></mat-icon>
      </a>
      <a [href]="'https://www.youtube.com/@k1m6a'" target="_blank">
        <mat-icon [svgIcon]="'youtube'"></mat-icon>
      </a>
      <a [href]="'https://x.com/k1m6a'" target="_blank">
        <mat-icon [svgIcon]="'x'"></mat-icon>
      </a>
      <a [href]="'https://twitch.tv/k1m6a'" target="_blank">
        <mat-icon [svgIcon]="'twitch'"></mat-icon>
      </a>
      <a [href]="'https://lnx.kimba.tv/merch'" target="_blank">
        <mat-icon [svgIcon]="'merch'"></mat-icon>
      </a>
    </div>
  </div>
</div>

<div class="content-wrapper">
  <h1>Tools & Resources</h1>
  <ng-container *ngFor="let category of order">
  <h2>{{ formatCategoryName(category) }}</h2>
  <div class="carousel">
    <div class="card" *ngFor="let item of groupedItems[category]">
      <img *ngIf="item.icon" [src]="item.icon" alt="{{ item.name }}" />
      <div class="card-content">
        <div class="card-name">{{ item.name }}</div>
        <div class="rating-block">
          <p class="card-tag">{{ item.tag }}</p>
          <div class="stars">
            <span class="rating-text">{{ item.rating }}</span>
            <ng-container *ngFor="let fill of getStars(+item.rating)">
              <span class="star" [style.--fill]="fill + '%'">★</span>
            </ng-container>
          </div>
        </div>
      </div>
      <a class="get-deal" [href]="item.url" target="_blank">Get Deal!</a>
    </div>
  </div>
</ng-container>
</div>

<div class="footer-wrapper">
  <div class="footer-content">
    <a [href]="'https://kimba.tv/'" target="_blank" class="footer-copyright">
      © 2025 Kimba.TV
    </a>
    <div class="footer-icons">
      <a [href]="'https://discord.gg/k1m6a'" target="_blank">
        <mat-icon [svgIcon]="'discord'"></mat-icon>
      </a>
      <a [href]="'https://www.youtube.com/@k1m6a'" target="_blank">
        <mat-icon [svgIcon]="'youtube'"></mat-icon>
      </a>
      <a [href]="'https://x.com/k1m6a'" target="_blank">
        <mat-icon [svgIcon]="'x'"></mat-icon>
      </a>
      <a [href]="'https://twitch.tv/k1m6a'" target="_blank">
        <mat-icon [svgIcon]="'twitch'"></mat-icon>
      </a>
      <a [href]="'https://lnx.kimba.tv/merch'" target="_blank">
        <mat-icon [svgIcon]="'merch'"></mat-icon>
      </a>
    </div>
  </div>
</div>